<div class="messages-container">
  <!-- Left Panel - Contacts -->
  <div class="contacts-panel">
    <!-- List Header -->
    <div class="list-header">
      <h2 *ngIf="selectedValue === 'clients' && product != 'content' && product != 'corporate'">List of Clients</h2>
      <h2 *ngIf="selectedValue === 'clients' && product == 'content'">List of Customers</h2>
      <h2 *ngIf="selectedValue === 'clients' && product == 'corporate'">List of External Counsels</h2>
      <h2 *ngIf="selectedValue === 'teams' && product != 'corporate'">List of Team Members</h2>
      <h2 *ngIf="selectedValue === 'teams' && product == 'corporate'">List of Departments</h2>
    </div>

    <!-- Search -->
    <div class="search-container">
      <div class="search-input-wrapper">
        <input
          type="text"
          class="search-input"
          placeholder="Search"
          [(ngModel)]="clientSearch"
          (input)="restricttextSpace($event)"
          (paste)="onPasteBlocked($event)"
          *ngIf="selectedValue === 'clients'" />
        <input
          type="text"
          class="search-input"
          placeholder="Search"
          [(ngModel)]="teamSearch"
          (input)="restricttextSpace($event)"
          (paste)="onPasteBlocked($event)"
          *ngIf="selectedValue === 'teams'" />
        <svg class="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
      </div>
    </div>

   
    <!-- Contacts List -->
<div class="contacts-list">
  <!-- <div *ngFor="let contact of getFilteredContacts(); trackBy: trackByGuid"> -->

  <div *ngFor="let contact of getFilteredContacts(); trackBy: trackByGuid">

    <div class="contact-item" #contactItem
      [class.active]="selectedContact?.id === contact.id"
      (click)="selectChatUser(contact)">

      <!-- Avatar -->
      <div class="contact-avatar-wrapper">
        <div class="contact-avatar" [ngClass]="getAvatarColor(contact.initials)">
          {{ contact.initials }}
        </div>
        <div class="online-indicator" *ngIf="contact.isOnline"></div>
      </div>

      <!-- Contact Info -->
            <!-- Contact Info -->
      <div class="contact-info">
        <div class="contact-header">
          <span class="contact-name">
            {{ contact.name }}
            <span *ngIf="selectedValue === 'clients' && contact.groupName"> - {{ contact.groupName }}</span>
          </span>

          <!-- Right side: time only -->
          <span class="contact-time" *ngIf="contact.lastMessageTimeDisplay">
            {{ contact.lastMessageTimeDisplay }}
          </span>
        </div>

        <!-- Latest message preview with unread badge -->
        <div class="contact-message-row">
          <p class="contact-last-message" *ngIf="contact.lastMessage">
            {{ contact.lastMessage | slice:0:40 }}{{ contact.lastMessage.length > 30 ? '...' : '' }}
          </p>
          <span class="unread-badge" *ngIf="contact.unreadCount && contact.unreadCount > 0">
            {{ contact.unreadCount }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

  </div>

  <!-- Right Panel - Chat -->
  <div class="chat-panel">
    <!-- Chat Header - Empty State -->
    <div class="chat-header-empty" *ngIf="!selectedContact">
      <h2>Chat</h2>
    </div>

    <!-- Chat Header - With Selected Contact -->
    <div class="chat-header" *ngIf="selectedContact">
      <!-- Back Button (Mobile) -->
      <button class="back-button" (click)="selectedContact = null">
        <svg class="back-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="m15 18-6-6 6-6"></path>
        </svg>
      </button>

      <!-- User Avatar -->
      <div class="chat-user-avatar-wrapper">
        <div class="chat-user-avatar" [ngClass]="getAvatarColor(selectedContact.initials)">
          {{ selectedContact.initials }}
        </div>
        <div class="online-indicator" *ngIf="selectedContact.isOnline"></div>
      </div>

      <!-- User Info -->
      <div class="chat-user-info">
        <h3 class="chat-user-name">
          {{ selectedContact.name }}<span *ngIf="selectedValue === 'clients' && selectedContact.groupName"> - {{ selectedContact.groupName }}</span>
        </h3>
        <p class="chat-user-status">{{ selectedContact.isOnline ? 'Online' : 'Offline' }}</p>
      </div>

      <!-- Chat Search -->
      <div class="chat-search-wrapper">
        <input
          type="text"
          class="chat-search-input"
          placeholder="Search messages"
          [(ngModel)]="chatSearchQuery" (ngModelChange)="onChatSearchChange()" (keyup.enter)="onChatSearchEnter()"/>
        <svg class="chat-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
      </div>

      <!-- Video Button -->
      <button class="video-button"  *ngIf="selectedContact.source !='appointment'" (click)="StartVideo()">
        <svg class="video-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="m22 8-6 4 6 4V8Z"></path>
          <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
        </svg>
      </button>
    </div>

	<!-- Messages Area -->
	<div class="messages-area" *ngIf="selectedContact && !isChatDisabled()" #scrollMe>
	<div class="messages-content">

		<!-- Pagination loader -->
		<div class="pagination-loader" *ngIf="isLoadingMore && messages.length > 0">
		<div class="chat-spinner"></div>
		</div>

		<!-- Messages grouped by date -->
		<div *ngFor="let date of getObjectKeys(groupFilteredMessagesByDate())">
		<div class="date-separator">
			<div class="date-badge">
			<span>{{ formatDateStamp(date) }}</span>
			</div>
		</div>
		<div class="messages-group">
			<div *ngFor="let message of groupFilteredMessagesByDate()[date]">
			<div class="message-wrapper" [class.message-own]="message.action === 'SENT'">
				<div [ngClass]="message.action === 'SENT' ? 'sender-bubble' : 'receiver-bubble'">
				<p class="message-text">{{ message.text }}</p>
				<span class="message-footer">
					<span class="message-time">{{ message.timestamp | date: 'h:mm a' }}</span>
          <!-- TODO: Implement message status indicators -->
					<!-- <span *ngIf="message.action === 'SENT'"
						[ngClass]="getMessageStatusIcon(message)"
						class="tick-icon">
					</span> -->
				</span>
				</div>
			</div>
			</div>
		</div>
		</div>

		<!-- Typing bubble INSIDE scroll area, after all messages -->
		<div class="typing-bubble-wrapper" *ngIf="isContactTyping">
		<div class="typing-bubble">
			<div class="typing-indicator">
			<span class="dots">
				<span></span><span></span><span></span>
			</span>
			</div>
		</div>
		</div>

	</div>
	</div>

    <!-- Empty State -->
    <div class="messages-area st" *ngIf="!selectedContact">
      <div class="empty-state">
        <div class="empty-icon">
         <i-lucide name="search" class="empty-search-icon"></i-lucide>
        </div>
        <h3 class="empty-title">Start a Conversation</h3>
        <p class="empty-subtitle">Select a contact to begin messaging</p>
      </div>
    </div>

    <!-- Chat Disabled State for Appointments -->
    <div class="messages-area" *ngIf="selectedContact && isChatDisabled()">
      <div class="chat-disabled-state">
        <p class="chat-disabled-message">Chat will be available 1 hour before your scheduled appointment</p>
      </div>
    </div>
	

    <!-- Message Input -->
    <div class="message-input-container" *ngIf="selectedContact && !isChatDisabled()">

     <textarea
        #messageInput
        class="message-input"
        placeholder="Type a message"
        [(ngModel)]="messegeInput"
		(input)="onInputChange()"
        (keydown)="onKeyDown($event)"
        rows="1">
      </textarea>

      <button
        class="send-button"
        (click)="sendMessage(messegeInput)"
        [disabled]="isMessageEmpty() || isChatDisabled()"
        [title]="isChatDisabled() ? 'Chat is not available for this appointment' : 'Send message'">
        <svg class="send-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="m22 2-7 20-4-9-9-4Z"></path>
          <path d="M22 2 11 13"></path>
        </svg>
      </button>
    </div>
  </div>
</div>

<!-- Video Call FAB -->
<!-- <div class="fab-container">
  <button mat-fab class="fab-video-button" aria-label="Video" matTooltip="Video Call" (click)="StartVideo()">
    <mat-icon>videocam</mat-icon>
  </button>
</div> -->

<ngx-spinner  name="chatLoader"size="medium" type="ball-clip-rotate"></ngx-spinner>